import { MAX_MESSAGE_LENGTH } from './constants';

export const getFileFromEvent = (event) => Array.from(event.target.files)[0];
export const sanitizeString = (string) => string.trim();

export const isValidMessage = (message) => {
  return message.length > 0 && message.length <= MAX_MESSAGE_LENGTH;
};
